import React from "react";
import { Box, Tooltip } from "@mui/material";
import { toPlainText } from "../../components/RichText";
import type { SimpleNamedItem } from "../types";

// Rich text arrives as a JSON string (AWSJSON) or an already-parsed object.
export const getPathDefinition = (item: SimpleNamedItem): string => {
  if (!item.description) return "";
  const asString =
    typeof item.description === "string"
      ? item.description
      : JSON.stringify(item.description);
  return toPlainText(asString) || "";
};

/**
 * Previews an After High School path's definition — the same text the Climb
 * Plan's path cards show. Renders the children untouched when none is authored.
 */
export const PathDefinitionTooltip = ({
  item,
  children,
}: {
  item: SimpleNamedItem;
  children: React.ReactNode;
}) => {
  const definition = getPathDefinition(item);
  if (!definition) return <>{children}</>;
  return (
    <Tooltip
      title={definition}
      placement="top"
      arrow
      enterTouchDelay={0}
      slotProps={{
        tooltip: {
          sx: {
            fontFamily: "Proxima Nova, sans-serif",
            fontSize: "13px",
            lineHeight: "20px",
            maxWidth: 280,
          },
        },
      }}
    >
      <Box
        component="span"
        tabIndex={0}
        aria-label={`${item.name}: ${definition}`}
        sx={{
          display: "inline-flex",
          cursor: "help",
          "&:focus-visible": { outline: "2px solid #078DEE", borderRadius: 1 },
        }}
      >
        {children}
      </Box>
    </Tooltip>
  );
};
